const radix64 = {
    _Rixits:
      "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz_-",
  
    isNumeric: function (value) {
        return /^-?\d+$/.test(value);
    },

    encode: function (input) {
      if (this.isNumeric(input)) {
        return this._encodeNumber(input);
      } else if (typeof input === 'string') {
        return this._encodeString(input);
      } else {
        throw "Invalid input type";
      }
    },
  
    decode: function (encoded) {
      // Try interpreting it as a number first
      let resultAsNumber = this._decodeNumber(encoded);
      if (Number.isSafeInteger(resultAsNumber)) {
        return resultAsNumber;
      } else {
        return this._decodeString(encoded);
      }
    },
  
    _encodeNumber: function (number) {
      if (isNaN(Number(number)) || number === null || number === Number.POSITIVE_INFINITY)
        throw "The number input is not valid";
      if (number < 0)
        throw "Can't represent negative numbers";
  
      return this._encodeGeneral(BigInt(number));
    },
  
    _decodeNumber: function (rixits) {
      let result = 0n;
      for (let char of rixits) {
        result = (result * 64n) + BigInt(this._Rixits.indexOf(char));
      }
      return Number(result);
    },
  
    _encodeString: function (input) {
      // Convert string to a big integer by treating characters as base-256 digits
      let bigIntValue = 0n;
      for (let i = 0; i < input.length; i++) {
        bigIntValue = (bigIntValue << 8n) + BigInt(input.charCodeAt(i));
      }
      return this._encodeGeneral(bigIntValue);
    },
  
    _decodeString: function (encoded) {
      let result = 0n;
      for (let char of encoded) {
        result = (result * 64n) + BigInt(this._Rixits.indexOf(char));
      }
  
      // Decode the entire number as characters
      let output = '';
      while (result > 0n) {
        output = String.fromCharCode(Number(result & 255n)) + output;
        result >>= 8n;
      }
      return output;
    },
  
    _encodeGeneral: function (bigInt) {
      let result = '';
      while (bigInt > 0n) {
        const rixit = bigInt % 64n;
        result = this._Rixits[Number(rixit)] + result;
        bigInt = bigInt / 64n;
      }
      return result || '0';
    },
  };

  module.exports = {
    radix64
  }